import * as React from 'react';
import PropTypes from 'prop-types';

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import ArrowIcon from '@material-ui/icons/KeyboardArrowRight';
import Divider from "@material-ui/core/Divider";

import TSideDrawer from '../../common/TSideDrawer';
import TBox from "../../common/TBox";
import * as rcc from '../NonVisual/RCConst';
import * as rcdu from "../NonVisual/RCDataUtil";
import * as Theme from '../../../app/Theme';

const indent1 = 20;
const indent2 = 40;

const menuItemStyle = {
    cursor       : "pointer",
    display      : "inline-block",
    marginBottom : 10,
    marginLeft   : indent2,
    marginTop    : 10,
};

class RCAppSideBar extends React.Component {

    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {

        appState            : PropTypes.object,

        pageID              : PropTypes.string,
        onPageChange        : PropTypes.func,

        sideBarOpen         : PropTypes.bool,
        onSideBarArrowClick : PropTypes.func,

        sideBarWidthOpen    : PropTypes.number,
        sideBarWidthClosed  : PropTypes.number,

    };

    static defaultProps = {

        appState            : {},


        pageID              : 0,
        onPageChange        : () => console.log('onPageChange'),

        sideBarOpen         : false,
        onSideBarArrowClick : () => console.log("onSideBarArrowClick"),

        sideBarWidthOpen    : 0,
        sideBarWidthClosed  : 0,

    };

    //==================================================================================================================
    //
    //                                              Utility Functions
    //
    //==================================================================================================================

    getArrow = (pageID) => {

        return (

            (this.props.pageID === pageID)

            ?

            <ArrowIcon
                style = {{
                    display   : "inline-block",
                    marginLeft : indent2,
                }}
            />

            :

            undefined

        );
    };

    getMenuItemName = (form) => {

        let menuItemName;

        switch (form) {

            case rcc.welcomeForm :
                menuItemName = RS(SC.GB_stChooseMode);
                break;

            case rcc.selectIndicatorsForm :
                menuItemName = RS(SC.GB_stSelectIndicators);
                break;

            case rcc.assignTargPopsForm :
                menuItemName = RS(SC.GB_stAssignTargPops);
                break;

            case rcc.parametersForm :
                menuItemName = RS(SC.GB_stParameters);
                break;

            case rcc.resultsForm :
                menuItemName = RS(SC.GB_stResults);
                break;

            default :
                menuItemName = "";
                break;
        }

        return menuItemName;

    };

    getMenuItemOnClickEvent = (form) => {

        let menuItemOnClickEvent;

        /* props */
        const props = this.props;
        const onPageChange = props.onPageChange;
        const appState = props.appState;
        const indicatorObjList = appState.indicatorObjList;
        const answer1Byte = appState.answer1Byte;

        const modeChosenBool = answer1Byte !== 0;
        const anyIndSelectedBool = rcdu.getAnyIndicatorSelected(indicatorObjList);
        const allIndCompleted = rcdu.allIndCompleted(indicatorObjList);

        const stdOnClickEvent = () => onPageChange(form);
        const emptyOnClickEvent = () => {};

        if (form === rcc.welcomeForm) {

            menuItemOnClickEvent = stdOnClickEvent;

        }
        else if (form === rcc.selectIndicatorsForm) {

            if (modeChosenBool) {

                menuItemOnClickEvent = stdOnClickEvent;

            }
            else {

                menuItemOnClickEvent = emptyOnClickEvent;

            }

        }
        else if (form === rcc.assignTargPopsForm) {

            if (modeChosenBool && anyIndSelectedBool) {

                menuItemOnClickEvent = stdOnClickEvent;

            }
            else {

                menuItemOnClickEvent = emptyOnClickEvent;

            }

        }
        else {

            if (modeChosenBool && anyIndSelectedBool && allIndCompleted) {

                menuItemOnClickEvent = stdOnClickEvent;

            }
            else {

                menuItemOnClickEvent = emptyOnClickEvent;

            }

        }

        return menuItemOnClickEvent;

    };

    getMenuItemDisabledStyle = (form) => {

        let menuItemDisabledStyle;

        /* props */

        const props = this.props;
        const appState = props.appState;
        const indicatorObjList = appState.indicatorObjList;
        const answer1Byte = appState.answer1Byte;

        const modeChosenBool = answer1Byte !== 0;
        const anyIndSelectedBool = rcdu.getAnyIndicatorSelected(indicatorObjList);
        const allIndCompleted = rcdu.allIndCompleted(indicatorObjList);

        const stdDisabledStyle = {
            color  : Theme.darkGrayColor,
            cursor : "arrow",
        };
        const emptyDisabledStyle = {};

        if (form === rcc.welcomeForm) {

            menuItemDisabledStyle = emptyDisabledStyle;

        }
        else if (form === rcc.selectIndicatorsForm) {

            if (modeChosenBool) {

                menuItemDisabledStyle = emptyDisabledStyle;

            }
            else {

                menuItemDisabledStyle = stdDisabledStyle;

            }

        }
        else if (form === rcc.assignTargPopsForm) {

            if (modeChosenBool && anyIndSelectedBool) {

                menuItemDisabledStyle = emptyDisabledStyle;

            }
            else {

                menuItemDisabledStyle = stdDisabledStyle;

            }

        }
        else {

            if (modeChosenBool && anyIndSelectedBool && allIndCompleted) {

                menuItemDisabledStyle = emptyDisabledStyle;

            }
            else {

                menuItemDisabledStyle = stdDisabledStyle;

            }

        }

        return menuItemDisabledStyle;

    };


    getMenuItemBox = (form) => {

        let menuItemBox;

        const props = this.props;
        const pageID = props.pageID;
        const sideBarOpen = props.sideBarOpen;

        const appState = props.appState;
        const indicatorObjList = appState.indicatorObjList;
        const answer1Byte = appState.answer1Byte;

        const modeChosenBool = answer1Byte !== 0;
        const anyIndSelectedBool = rcdu.getAnyIndicatorSelected(indicatorObjList);

        let firstItemStyle = {};

        /* These depend on whether or not the user selected a mode yet. */
        const menuItemDisabledStyle = this.getMenuItemDisabledStyle(form);
        const menuItemOnClickEvent = this.getMenuItemOnClickEvent(form);

        let arrow = null;
        let menuItem = null;

        if (sideBarOpen) {

            if (!modeChosenBool) {

                /* We don't want space between the play arrow button and the first item, since
                   it will look ugly. */
                firstItemStyle = {

                    alignItems : "flex-start",

                };

            }

            let activePageStyle = {};

            if (pageID === form) {

                activePageStyle = {
                    marginLeft : 10,
                };

            }

            arrow = this.getArrow(form, firstItemStyle);
            menuItem =
                <p
                    disabled = {!anyIndSelectedBool}
                    key      = {form + "MenuItem"}
                    onClick  = {menuItemOnClickEvent}
                    style    = {{
                        ...menuItemStyle,
                        ...menuItemDisabledStyle,
                        ...activePageStyle,
                    }}
                >
                    {this.getMenuItemName(form)}
                </p>;

        }

        let menuItemBoxContents = [];
        menuItemBoxContents.push(arrow);
        menuItemBoxContents.push(menuItem);

        menuItemBox =
            <TBox
                content        = {menuItemBoxContents}
                key            = {form + "Box"}
                justifyContent = {"flex-start"}
                style          = {{
                    padding : 0,
                }}
            />;

        return menuItemBox;

    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {

        /* Props */
        const props = this.props;
        const appState = props.appState;
        const sideBarOpen = props.sideBarOpen;
        const sideBarWidthClosed = props.sideBarWidthClosed;
        const sideBarWidthOpen = props.sideBarWidthOpen;

        const answer1Byte = appState.answer1Byte;

        const modeChosen = answer1Byte !== 0;

        let modeLab = null;
        let modeDivider = null;

        if (sideBarOpen) {

            if (modeChosen) {

                let modeStr;
                if (rcc.precisionQ1A === answer1Byte) {

                    modeStr = RS(SC.GB_stPrecision);

                }
                else {

                    modeStr = RS(SC.GB_stPowerChange);

                }
                modeLab =
                    <p
                        style = {{
                            display      : "inline-block",
                            fontSize     : 18,
                            marginBottom : 10,
                            marginLeft   : indent1,
                            marginTop    : 0,
                        }}
                    >
                        {modeStr}
                    </p>;

                modeDivider = <Divider/>;

            }

        }

        const welcomeBox = this.getMenuItemBox(rcc.welcomeForm);
        const selectedIndicatorsBox = this.getMenuItemBox(rcc.selectIndicatorsForm);
        const assignTargPopsBox = this.getMenuItemBox(rcc.assignTargPopsForm);
        const parametersBox = this.getMenuItemBox(rcc.parametersForm);
        const resultsBox = this.getMenuItemBox(rcc.resultsForm);

        return (

            <TSideDrawer
                direction   = "left"
                expanded    = {sideBarOpen}
                header      = {false}
                style       = {{
                    backgroundColor : Theme.whiteColor,
                }}
                widthClosed = {sideBarWidthClosed}
                widthOpen   = {sideBarWidthOpen}
            >
                <div
                    style = {{
                        marginTop : 20,
                    }}
                >
                    {modeLab}
                    {modeDivider}
                </div>
                {welcomeBox}
                {selectedIndicatorsBox}
                {assignTargPopsBox}
                {parametersBox}
                {resultsBox}
            </TSideDrawer>

        );

    }

}

export default RCAppSideBar;